module.exports = __webpack_public_path__ + "static/media/Call_Button.08efe476.png";